import { useTheme } from "@emotion/react";
import { faCheck, faRotate } from "@fortawesome/free-solid-svg-icons";
import React, { useEffect, useState } from "react";
import copyText from "../copyText";
import Box from "./Box";
import Flex from "./Flex";
import Icon from "./Icon";
import Text from "./Text";

type AutosaveIndicatorProps = {
  isSaving: boolean;
  delayToHide?: number;
};

export function AutosaveIndicator(props: AutosaveIndicatorProps) {
  const [hasSaved, setHasSaved] = useState(false);
  const theme = useTheme();

  useEffect(() => {
    if (props.isSaving) {
      setHasSaved(true);
    }
  }, [props.isSaving]);

  useEffect(() => {
    if (hasSaved && props.delayToHide) {
      const timer = setTimeout(() => {
        setHasSaved(false);
      }, props.delayToHide);

      return () => clearTimeout(timer);
    }
  }, [hasSaved, props.delayToHide]);

  return (
    <Flex
      alignItems="center"
      justifyContent="space-between"
      paddingHorizontal={theme.space_sm}
      transition="opacity 0.3s ease-in-out"
      opacity={!props.isSaving && !hasSaved ? 0 : 1}
    >
      <Text color={theme.text_color_secondary}>
        {props.isSaving
          ? copyText.autosaveSaving
          : copyText.autosaveChangesSaved}
      </Text>

      <Box color={theme.text_color_secondary} marginLeft={theme.space_sm}>
        {props.isSaving ? <Icon icon={faRotate} /> : <Icon icon={faCheck} />}
      </Box>
    </Flex>
  );
}
